import React, {FC} from "react"

import authentication from "@irati/auth"
import {ReportType} from "@irati/types"
import rewardsReportService from "@irati/wallet/services/rewardsReporting"
import adminTracking, {ViewType, Product} from "@irati-tracking/admin/admin"
import {GridCentered} from "@irati/ui/src/Layout"
import ReportingCard from "./ReportingCard"

const ReportingSection: FC = () => {
  const canViewFullReports = !!authentication.apps("wallet.flexiRewards.canViewFullReports")
  const userId = canViewFullReports ? undefined : authentication.user().uuid
  return (
    <GridCentered maxColumns={2}>
      <ReportingCard
        reportId={ReportType.FlexipointsTransactions}
        title="platform.wallet.reward.reports.cardOne.title"
        body="platform.wallet.reward.reports.cardOne.body"
        onClick={() => handleCSVDownload({report: ReportType.FlexipointsTransactions, product: Product.pointsBought, userId})}
      />
      <ReportingCard
        reportId={ReportType.PointsBalance}
        title="platform.wallet.reward.reports.cardTwo.title"
        body="platform.wallet.reward.reports.cardTwo.body"
        onClick={() => handleCSVDownload({report: ReportType.PointsBalance, product: Product.pointsTransferred, userId})}
      />
      {canViewFullReports && (
        <ReportingCard
          reportId={ReportType.PointsTransactions}
          title="platform.wallet.reward.reports.cardThree.title"
          body="platform.wallet.reward.reports.cardThree.body"
          onClick={() => handleCSVDownload({report: ReportType.PointsTransactions, product: Product.pointsSpent, userId})}
        />
      )}
      {canViewFullReports && (
        <ReportingCard
          reportId={ReportType.ManagerWallet}
          title="platform.wallet.reward.reports.cardFour.title"
          body="platform.wallet.reward.reports.cardFour.body"
          onClick={() => handleCSVDownload({report: ReportType.ManagerWallet, product: Product.managerWallet, userId})}
        />
      )}
    </GridCentered>
  )
}

interface HandleCSV {
  report: ReportType
  product: Product
  userId?: string
}

async function handleCSVDownload({report: reportType, userId, product}: HandleCSV) {
  adminTracking.reporting({
    source: "Navigation",
    type: "celebration_rewardTransactions",
    viewType: ViewType.default,
    product,
    action: "downloadReport"
  })

  const {reportFileUrl} = await rewardsReportService.getRewardsReportUrl(
    {
      businessId: authentication.business().uuid,
      reportType,
      userId
    },
    {fetchPolicy: "network-only"}
  )

  const fileName = reportType.toLowerCase()
  const link = document.createElement("a")
  link.setAttribute("href", reportFileUrl)
  link.setAttribute("target", "_blank")
  link.setAttribute("download", fileName)
  link.style.visibility = "hidden"
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export default ReportingSection
